import React from "react";
import PropTypes from "prop-types";

import Tooltip from "core/Tooltip";
import CircleButton from "core/CircleButton";

import { ModalButtonContainer } from "./styles";

const ModalButton = ({
    tooltipMessage,
    isProcessing,
    isToggled,
    icon,
    onClick
}) => {
    return (
        <ModalButtonContainer>
            <Tooltip size="small" message={tooltipMessage}>
                <CircleButton
                    darkMode
                    title={tooltipMessage}
                    isProcessing={isProcessing}
                    isToggled={isToggled}
                    icon={icon}
                    onClick={onClick}
                    styleType="secondary"
                    size="md"
                />
            </Tooltip>
        </ModalButtonContainer>
    );
};

ModalButton.propTypes = {
    tooltipMessage: PropTypes.string.isRequired,
    isProcessing: PropTypes.bool,
    isToggled: PropTypes.bool,
    icon: PropTypes.element,
    onClick: PropTypes.func
};

export default ModalButton;
